module.exports = __webpack_public_path__ + "static/media/adjuge-ro.a9db7ddc.png";